import { render, staticRenderFns } from "./Vips.vue?vue&type=template&id=4c4ec56c&"
import script from "./Vips.vue?vue&type=script&lang=js&"
export * from "./Vips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports